// src/App.js
import React from 'react';
import { Navigate, Routes, Route } from 'react-router-dom';
import useKeyboardBack from './hooks/useKeyboardBack';
import AdminDashboard from './pages/AdminDashboard';
import TeachersPage from './pages/TeachersPage';
import LoginPage from './pages/LoginPage';
import DashboardPage from './pages/DashboardPage';
import PrivateRoute from './components/PrivateRoute';
import RegisterPage from './pages/RegisterPage';
import AddStudentPage from './pages/AddStudentPage';
import AddQuestionPage from './pages/AddQuestionPage';
import QuestionListPage from './pages/QuestionListPage';
import EditQuestionPage from './pages/EditQuestionPage';
import ActivityLogPage from './pages/ActivityLogPage';
import TeacherLessonManager from './pages/TeacherLessonManager';
import Footer from './components/Footer';
import ParentReportPage from './pages/ParentReportPage';
import StudentManagerPage from './pages/StudentManagerPage';
import AttendancePage from './pages/AttendanceTabs';
import AdminAttendancePage from './pages/AdminAttendancePage';

function App() {
  useKeyboardBack('/dashboard');

  return (
    <>
      <Routes>
        <Route path="/" element={<Navigate to="/login" replace />} />
        <Route path="/login" element={<LoginPage />} />
        <Route path="/register" element={<RegisterPage />} />
        <Route path="/add-student" element={<AddStudentPage />} />
        <Route path="/add-question" element={<AddQuestionPage />} />
        <Route path="/questions" element={<QuestionListPage />} />
        <Route path="/edit-question/:id" element={<EditQuestionPage />} />
        <Route path="/teacher-lessons" element={<TeacherLessonManager />} />
        <Route path="/parent-report/:tokenOrId" element={<ParentReportPage />} />
        <Route path="/activity-log" element={<ActivityLogPage />} />

        <Route
          path="/attendance"
          element={
            <PrivateRoute>
              <AttendancePage />
            </PrivateRoute>
          }
        />

        <Route
          path="/teachers"
          element={
            <PrivateRoute>
              <TeachersPage />
            </PrivateRoute>
          }
        />

        <Route
          path="/students"
          element={
            <PrivateRoute>
              <StudentManagerPage />
            </PrivateRoute>
          }
        />

        <Route
          path="/dashboard"
          element={
            <PrivateRoute>
              <DashboardPage />
            </PrivateRoute>
          }
        />

        <Route
          path="/admin"
          element={
            <PrivateRoute requiredRole="Admin">
              <AdminDashboard />
            </PrivateRoute>
          }
        />

        <Route
          path="/admin/attendance"
          element={
            <PrivateRoute requiredRole="Admin">
              <AdminAttendancePage />
            </PrivateRoute>
          }
        />

        <Route path="*" element={<Navigate to="/dashboard" replace />} />
      </Routes>

      <Footer author="احسان فخریان" />
    </>
  );
}

export default App;